import { createSelector } from 'reselect';

const getState = state => state.appointments.data;

const getId = (_, id) => id;

export const isLoading = createSelector(getState, state => state.isLoading);

export const getApiError = createSelector(getState, state => state.apiError);

export const getAll = createSelector(getState, state => state.byId);

export const getById = createSelector(getAll, getId, (collection, id) => collection?.[id]);
